import { render } from "./excelExport.vue?vue&type=template&id=10d941b6&scoped=true"
import script from "./excelExport.vue?vue&type=script&lang=ts"
export * from "./excelExport.vue?vue&type=script&lang=ts"

import "./excelExport.vue?vue&type=style&index=0&id=10d941b6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-10d941b6"

export default script